import React from 'react';
import styles from '../style.module.css';

const EstimatedTotalExplainer = () => {
    return (
      <>
        <h1 className={styles.tooltipHeader}>Why we estimate the total</h1>
        <p>When placing an order, each medication will show an item charge.</p>
        <br />
        <p>The charge amount is set nationally by the NHS.</p>
        <br />
        <p>
          If the GP issues more or less than what you ordered, the total order amount will change. We’ll let you know if
          this happens.
        </p>
        <br />
        <p>Full payment is taken at the point your order is dispatched.</p>
        <br />
        <h2 className={styles.tooltipSubHeader}>
          Why does it look like I’m being charged more than I would be at a local pharmacy?
        </h2>
        <p>
          If you have multiple strengths of one medication (must be same form, i.e. tablet or capsule) on the same
          prescription, the charge will be shown per item, but once we dispatch your order you’ll only pay one
          charge.
        </p>
        <br />
        <h2 className={styles.tooltipSubHeader}>Example</h2>
        <p>
          You order Sertraline 50mg tablets and Sertraline 100mg tablets. This will show two charges, but once we
          dispatch your order you’ll only be charged once for both items.
        </p>
      </>
    );
};

export default EstimatedTotalExplainer;